import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';

import { IonPicker, IonPickerColumn, IonPickerColumnOption } from '@ionic/angular/standalone';

import { ContentService } from '@core/services/content.service';
import { ModalService } from '@core/services/modal.service';

import { Button } from '@shared/components/button/button';
import { usStates } from '@shared/constants/us-states';
import { UniversalModalTemplate } from '@shared/universal-modal-template/universal-modal-template';

import type { StatePickerModalContent } from './state-picker-modal.types';

@Component({
  selector: 'app-state-picker-modal',
  templateUrl: 'state-picker.modal.html',
  imports: [IonPicker, IonPickerColumn, IonPickerColumnOption, Button, UniversalModalTemplate],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ContentService],
})
export class StatePickerModal {
  private readonly contentService = inject(ContentService<StatePickerModalContent>);
  private readonly modalService = inject(ModalService);

  readonly selectedState = input<string>('Texas');

  protected readonly state = this.contentService.state;
  protected readonly content = computed(() => this.state().getData());

  protected readonly states = usStates;
  protected readonly currentValue = signal<string>('Texas');

  constructor() {
    afterNextRender(() => {
      this.contentService.loadModalContent('statePicker');
    });

    effect(
      () => {
        const initial = this.selectedState();
        if (initial) {
          this.currentValue.set(initial);
        }
      },
      { allowSignalWrites: true },
    );
  }

  protected onPickerChange(event: CustomEvent): void {
    this.currentValue.set(event.detail.value);
  }

  protected confirm(): void {
    this.modalService.dismissLatest(this.currentValue());
  }

  protected close(): void {
    this.modalService.dismissLatest();
  }
}
